export {
  Card as TestimonialCard,
  type CardProps as TestimonialCardProps,
} from "./ui";
